import { Menu as RaMenu } from "react-admin";
import BarChartIcon from "@mui/icons-material/BarChart";

export const Menu = () => (
	<RaMenu>
		<RaMenu.ResourceItem name="missions" />
		<RaMenu.ResourceItem name="organs" />
		<RaMenu.ResourceItem name="teams" />
		<RaMenu.ResourceItem name="users" />
		<RaMenu.Item
			to="/analytics"
			primaryText="Analytics"
			leftIcon={<BarChartIcon />}
		/>
	</RaMenu>
);
